import { Component, OnInit } from '@angular/core';
import { TermpageService } from './usLegalPage.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { PosthogService } from 'src/app/shared/services/posthog.service';
import { UsLegalContentComponent } from './us-legal-content/us-legal-content.component';
import { UsLegalSupportComponent } from './us-legal-support/us-legal-support.component';

@Component({
  selector: 'app-us-legal',
  templateUrl: './us-legal.component.html',
  styleUrls: ['./us-legal.component.scss'],
  imports: [UsLegalContentComponent, UsLegalSupportComponent],
})
export class UsLegalComponent implements OnInit {
  pageData:any;
  getUrl: any;
  metaBody = {
    title: '',
    description: '',
    url: '',
    image: '',
    type: '',
  };
  constructor(
    private termpageService: TermpageService,
    private meta: MetaService,
    private route: ActivatedRoute,
    private canonical: CanonicalService,
    private router: Router,
    private posthogService: PosthogService
  ) {
    this.getUrl = this.router.url;
  }

  ngOnInit(): void {
    this.termpageService.gettermPageData();
    this.pageData = this.route.snapshot.data?.['seo']?.[0]?.fields;
    this.meta.updateMeta(
      this.route.snapshot.data?.['seo']?.[0]?.fields?.seoMetadataReference
        ?.fields
    );
    this.canonical.setCanonicalURL();
    let data = this.route.snapshot.data?.['seo']?.[0]?.fields;
    this.metaBody.title = data?.seoMetadataReference?.fields?.title || 'Verto: Cross-border payments platform for businesses';
    this.metaBody.description = data?.seoMetadataReference?.fields?.description || 'Verto: Cross-border payments platform for businesses across the globe.';
    this.metaBody.type = 'US Legal';
    this.metaBody.url = this.getUrl;
    this.metaBody.image = '';
    this.meta.updateOG(this.metaBody);

    this.posthogService.capturePageViewEvent('us_legal');
  }
}
